import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTable = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M12 3v18" }),
		/* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			x: 3,
			y: 3,
			rx: 2
		}),
		/* @__PURE__ */ _jsx("path", { d: "M3 9h18" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 15h18" })
	]
});
const ForwardRef = forwardRef(SvgTable);
export default ForwardRef;
